import index from "./index.vue";
import { getSingle, createdRoot } from '@/js/api/utils';
var Toast = {};

// 注册Toast
Toast.install = function (Vue) {
  // 生成一个Vue的子类
  // 同时这个子类也就是组件
  var newConstructor = Vue.extend(index);
  // 生成一个该子类的实例
  var instance = new newConstructor();

  // 通过Vue的原型注册一个方法
  // 让所有实例共享这个方法
  Vue.prototype.$toast = function () {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;
    var isMask = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // 将这个实例挂载在我创建的div上
    // 并将此div加入全局挂载点内部
    // 优化：封装并使用单例模式创建并挂载节点
    var createdSingle = getSingle(createdRoot(instance));
    createdSingle();
    instance.message = message;
    instance.show = true;
    instance.isMask = isMask;
    clearTimeout(window.toastTimer);
    if (duration) {
      window.toastTimer = setTimeout(function () {
        instance.show = false;
      }, duration);
    }
  };
};
export default Toast;